export const toCamelCase = (str: string) =>
  str
    ?.replace(/-/g, ' ')
    .split(' ')
    ?.map((item) => item.charAt(0).toUpperCase() + item.slice(1))
    .join(' ');
